import React, { useState, useEffect, useRef } from "react";



import { Lightbox } from "react-modal-image";



const File_view = (value) => {
   // console.log("value- url ------->  ",value);
    const [urlMsg, setUrlMsg] = useState({ urlTitle: "", urlDescription: "",url:"",urlImg:"",urlFavicons:"" })
    const [state,setState] = useState({fileType:0,file:""});
    const [lightbox, setLightbox] = useState(false)
    const [lightboxFile, setLightboxFile] = useState({ file: "" })
    const [modals, setModals] = useState({ show: false });
    useEffect(() => {
        MessageFileView()
    },[])


    function getExtension(filename) {
        var parts = filename.split('.');
        return parts[parts.length - 1];
    }

    const handleOpen = (files) =>{
        setLightboxFile(files.files)
        setLightbox(true)  
  
    } 
    const MessageFileView = () => {
        let file = value.value;
       // console.log("file   ", file);
        var ext = getExtension(file).toLowerCase();
       //console.log("ext   ", ext);
        let imageType = ['jpg','jpeg','png'];
        let videoType = ['mp4'];
        let audioType = [];
       // console.log("image -==>   ", imageType.indexOf(ext));
        if(imageType.indexOf(ext) != -1){            
            setState({...state,fileType: 1,file:file});            
        }
        if(videoType.indexOf(ext) != -1){
            setState({...state,fileType: 2,file:file});            
        }
           
    }

    return (
        
        <>  
        {(lightbox) ?
                <Lightbox
                    medium={"https://mojocdn.fniix.com/web/" + lightboxFile}
                    large={"https://mojocdn.fniix.com/web/" + lightboxFile}
                    onClose={() => setLightbox(false)} />
                : ""
            }
        {(state.fileType == 1) ?     
      <img src={"https://mojocdn.fniix.com/web/" + state.file} style={{ width: "20%", float: "right", marginBottom: "10px", marginRight: "15px" }} height="120px" onClick={() => handleOpen({ files: state.file })} />
:(state.fileType == 2) ?
    <video width="320" height="240" src={"https://mojocdn.fniix.com/web/" +state.file} controls   style={{float: "right"}}/> :""
        }           
        </>
        )

}

export default File_view;